
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

// Connect SunXwear's product form to Shopify's existing cart drawer.
if (!window.__sunxCartBridgeInstalled) {
  window.__sunxCartBridgeInstalled = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('form.sunx-product-form')
    ) return;

    event.preventDefault();
    if (!form.reportValidity()) return;

    const button = event.submitter instanceof HTMLButtonElement
      ? event.submitter
      : form.querySelector('button[data-add-cart]');

    if (button?.disabled) return;

    const data = new FormData(form);

    const logoChoice = localStorage.getItem('sunx_logo_choice');

if (logoChoice === 'on_file') {
  data.set('properties[Logo Source]', 'Logo On File');

  const logoName = localStorage.getItem('sunx_logo_name') || '';
  const previousOrder = localStorage.getItem('sunx_logo_order') || '';

  if (logoName) {
    data.set('properties[Logo / Company Name]', logoName);
  }

  if (previousOrder) {
    data.set('properties[Previous Order Number]', previousOrder);
  }
}
    const variantId = String(data.get('id') || '');
    const quantity = Math.max(1, Number(data.get('quantity')) || 1);

    if (!variantId) {
      alert('Please select a product option.');
      return;
    }

    const sectionIds = [
      ...document.querySelectorAll('cart-items-component[data-section-id]')
    ].map(node => node.dataset.sectionId).filter(Boolean);

    if (!sectionIds.includes('cart-drawer-section')) {
      sectionIds.push('cart-drawer-section');
    }

    data.set('sections', sectionIds.join(','));
    data.set('sections_url', window.location.pathname);

    const deferred = CartLinesUpdateEvent.createPromise();

    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity }],
      promise: deferred.promise
    }));

    const oldLabel = button?.textContent;

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description || result.message || 'Could not add to cart.'
        );
      }

      const cartResponse = await fetch(`${root}cart.js`, {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) {
        throw new Error('Cart refresh failed.');
      }

      const cart = await cartResponse.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: result.sections,
          source: 'sunx-cart-bridge',
          didError: false
        }
      });

    } catch (error) {
      deferred.resolve({
        detail: { didError: true }
      });

      form.dispatchEvent(new CartErrorEvent({
        error: error.message || 'Unable to add product.',
        code: 'INVALID'
      }));

      alert(error.message || 'Unable to add product. Please try again.');

    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = oldLabel;
      }
    }
  }, true);
}
